import { Icon, TableItem, Text, Tooltip, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, IconButton } from 'native-base';
import React from 'react';

import { fundPositionStatememntsWidthCols } from '../../../../../../constants';
import { PositionItemDetails } from '../PositionItemDetails';

import { PositionItemResponsiveProps } from '.';

export const PositionItemDesktop: React.FC<PositionItemResponsiveProps> = ({
  handleChangeIsOpened,
  isOpened,
  fundName,
  applicationDate,
  profitabilityPosition,
  quotaValue,
  totalQuota,
  totalApplication,
  iofValueTotal,
  totalGrossTotal,
  irValueTotal,
  netValueTotal,
  hasMultiplePositions,
  fundPositions,
}) => {
  return (
    <VStack>
      <HStack
        alignItems="center"
        marginBottom={Spacing['inset.nano']}
        borderRadius={BoxRadius.sm}
        justifyContent="space-between"
        py={Spacing['inline.xxxs']}
        px={{ base: 0, lg: Spacing['inline.quarck'] }}>
        <TableItem
          testId="statement-fund-position-item-name"
          width={fundPositionStatememntsWidthCols.name.desktop}>
          <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
            {fundName}
          </Text>
        </TableItem>
        <TableItem
          testId="statement-fund-position-item-application-date"
          width={fundPositionStatememntsWidthCols.applicationDate.desktop}>
          <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
            {applicationDate}
          </Text>
        </TableItem>
        <TableItem
          testId="statement-fund-position-item-profitability"
          width={fundPositionStatememntsWidthCols.profitability.desktop}>
          <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
            {profitabilityPosition}
          </Text>
        </TableItem>
        <TableItem
          testId="statement-fund-position-item-quota-value"
          width={fundPositionStatememntsWidthCols.quota.desktop}>
          <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
            {quotaValue}
          </Text>
        </TableItem>
        <TableItem
          testId="statement-fund-position-item-total-quota-quantity"
          width={fundPositionStatememntsWidthCols.quantity.desktop}>
          <Tooltip label={String(totalQuota || '')}>
            <Box maxW="90px">
              <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
                {totalQuota}
              </Text>
            </Box>
          </Tooltip>
        </TableItem>
        <TableItem
          testId="statement-fund-position-item-total-value-applied"
          width={fundPositionStatememntsWidthCols.valueApplied.desktop}>
          <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
            {totalApplication}
          </Text>
        </TableItem>
        <TableItem
          testId="statement-fund-position-item-total-value-gross-value"
          width={fundPositionStatememntsWidthCols.grossValue.desktop}>
          <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
            {totalGrossTotal}
          </Text>
        </TableItem>
        <TableItem
          testId="statement-fund-position-item-total-ir-value"
          width={fundPositionStatememntsWidthCols.ir.desktop}>
          <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
            {irValueTotal}
          </Text>
        </TableItem>
        <TableItem
          testId="statement-fund-position-item-total-iof-value"
          width={fundPositionStatememntsWidthCols.iof.desktop}>
          <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
            {iofValueTotal}
          </Text>
        </TableItem>
        <TableItem
          testId="statement-fund-position-item-total-net-value"
          width={fundPositionStatememntsWidthCols.netValue.desktop}>
          <HStack alignItems={'center'} w={'full'} justifyContent={'space-between'}>
            <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
              {netValueTotal}
            </Text>
            {hasMultiplePositions && (
              <IconButton
                p={0}
                onPress={handleChangeIsOpened}
                variant="unstyled"
                icon={
                  <Icon
                    testID="accordion-chevron-icon"
                    name={isOpened ? 'ChevronUp' : 'ChevronDown'}
                    size={'xs'}
                    color={Color['neutral.dark']}
                  />
                }
              />
            )}
          </HStack>
        </TableItem>
      </HStack>
      {isOpened && hasMultiplePositions && <PositionItemDetails fundPositions={fundPositions} />}
    </VStack>
  );
};
